import React from "react";

class AppsFeature extends React.Component {
    render() {
        // to make a banner: remove className `container row` and add class banner
        return (
            <div
                className="custom-block AppsFeature-background-image banner margin-t-xxl"
                style={{ backgroundColor: "#FAFAFA" }}
            >
                <style>
                    {`
                .AppsFeature-inner{
                    max-width: 1200px;
                    margin: auto;
                }
                .AppsFeature-text-box{
                    text-align: left;
                    color: #000000;
                }
                @media (max-width: 768px) {
                    .AppsFeature-inner .row{
                        flex-direction: column-reverse;
                    }
                    .AppsFeature-inner .font-xxlarge{
                        margin-top: 0;
                    }
                    .AppsFeature-inner .AppsFeature-text-box{
                        padding: 0 24px 24px 24px;
                    }
                }
            `}
                </style>
                <div className="AppsFeature-inner padding-t-xl padding-b-xl">
                    <div className="container">
                        <div className="row" style={{ alignItems: "center" }}>
                            <div className="AppsFeature-text-box col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <h1 className="font-xxlarge">
                                    In your Google Slides and&nbsp;Docs
                                </h1>
                                <p
                                    className="font-medium weight-light"
                                    style={{ maxWidth: "400px" }}
                                >
                                    Quickly find the icon you want, change its
                                    color and size, then insert it right into
                                    your Google Slides or Google&nbsp;Docs.
                                </p>
                                <div className="margin-b-l margin-t-l">
                                    <img
                                        src={require("../../img/homepage/google_logos_and_icons@2x.png")}
                                        width="302"
                                        height="24"
                                    />
                                </div>
                                <a
                                    href="/for-google/"
                                    className="button small green"
                                >
                                    Learn more
                                </a>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 padding-m">
                                <img
                                    src={require("../../img/homepage/temp_slides@2x.png")}
                                    width="100%"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = AppsFeature;
